import { ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Verified } from '@sorare/core/src/atoms/icons/Verified';
import { LabelS } from '@sorare/core/src/atoms/typography';
import { CornerBadge } from '@sorare/core/src/components/CornerBadge';

const Label = styled(LabelS)`
  white-space: nowrap;
`;

type Props = {
  marketCredit?: ReactNode;
  bestValue?: boolean;
  bestPrice?: boolean;
  highestLevel?: boolean;
};

export const CornerBadges = ({
  marketCredit,
  bestValue,
  bestPrice,
  highestLevel,
}: Props) => {
  const hasCornerBadges =
    bestValue || marketCredit || bestPrice || highestLevel;

  if (!hasCornerBadges) return null;
  return (
    <>
      {bestValue && (
        <CornerBadge color="var(--c-brand-600)">
          <Verified fill="var(--c-white)" />
          <Label bold color="var(--c-white)">
            <FormattedMessage
              id="PlayerDrawerToken.primaryOffer.cornerBadge"
              defaultMessage="Best value"
            />
          </Label>
        </CornerBadge>
      )}
      {marketCredit}
      {bestPrice && (
        <CornerBadge color="var(--c-nd-150-opaque)">
          <Label bold color="var(--c-white)">
            <FormattedMessage
              id="PlayerDrawerToken.bestPrice.cornerBadge"
              defaultMessage="Best price"
            />
          </Label>
        </CornerBadge>
      )}
      {highestLevel && (
        <CornerBadge color="var(--c-nd-150-opaque)">
          <Label bold color="var(--c-white)">
            <FormattedMessage
              id="PlayerDrawerToken.highestLevel.cornerBadge"
              defaultMessage="Highest level"
            />
          </Label>
        </CornerBadge>
      )}
    </>
  );
};
